import { render, staticRenderFns } from "./videoCom.vue?vue&type=template&id=6f666d37&"
import script from "./videoCom.vue?vue&type=script&lang=js&"
export * from "./videoCom.vue?vue&type=script&lang=js&"
import style0 from "./videoCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports